// extracted by mini-css-extract-plugin
module.exports = {"host":"styles_host__OEURE","host__image":"styles_host__image__APL2N","host__details":"styles_host__details___mjRZ","pulse":"styles_pulse___S_pb","jump":"styles_jump__I6Wnj"};